import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import classes from "./AssignnUser.module.css";
import { BiSolidEdit } from "react-icons/bi";
import { Spinner, Button, Modal, Form, Accordion } from 'react-bootstrap';
import HeaderNav from "../../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const AssignUser = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [tableData5, setTableData5] = useState([]);
  const [selectedProvinces, setSelectedProvinces] = useState([]);
  const [userProvinces, setUserProvinces] = useState([]);

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      if (value !== null) {
        setBearer(value);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  // Fetch users from API
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/users/get-all-compliances`, { headers });
      console.log("Full API Response:", response.data);

      if (response.data.status && Array.isArray(response.data.data)) {
        setUsers(response.data.data);
        console.log("Users data:", response.data.data);
      } else {
        console.error("Unexpected API response structure:", response.data);
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data for modals
  const fetchContinents = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      if (response.data.status) {
        const options = response.data.data.map((item) => ({
          label: item.description,
          value: item.id,
        }));
        setSelectOptions(options);
      }
    } catch (error) {
      console.error("Error fetching continents:", error);
    }
  };

  const fetchRegions = async (continentId) => {
    if (!continentId) {
      setTableData4([]);
      return;
    }
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      let regionsData = [];
      if (response.data.status && response.data.data) {
        regionsData = Array.isArray(response.data.data) ? response.data.data : response.data.data.regions || [];
      }
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setTableData4([]);
    }
  };

  const fetchProvinces = async (regionId) => {
    if (!regionId) {
      setTableData5([]);
      return;
    }
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`, { headers });
      let provincesData = [];
      if (response.data.status) {
        if (response.data.data && response.data.data.provinces) {
          provincesData = response.data.data.provinces;
        } else if (Array.isArray(response.data.data)) {
          provincesData = response.data.data;
        }
      }
      const options = provincesData.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData5(options);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setTableData5([]);
    }
  };

  // Get assigned provinces from the user data (no need for separate API call)
  const getAssignedProvinces = (user) => {
    if (!user?.assigned_provinces || user.assigned_provinces.length === 0) {
      return [];
    }

    return user.assigned_provinces.map((province) => ({
      label: province.province_name,
      value: province.province_id,
    }));
  };

  useEffect(() => {
    if (bearer) {
      fetchData();
      fetchContinents();
    }
  }, [bearer]);

  // Modal handlers
  const handleShow = (user) => {
    setSelectedUser(user);
    setSelectedProvinces([]);
    setUserProvinces([]);
    setShow(true);
  };

  const handleShow1 = (user) => {
    setSelectedUser(user);
    setUserProvinces([]);
    setShow2(true);
  };

  const handleClose = () => setShow(false);
  const handleClose2 = () => setShow2(false);

  const handleContinentChange = (selectedOption) => {
    setSelectedProvinces([]);
    setTableData5([]);
    if (selectedOption) {
      fetchRegions(selectedOption.value);
    } else {
      setTableData4([]);
    }
  };

  const handleRegionChange = (selectedOption) => {
    setSelectedProvinces([]);
    if (selectedOption) {
      fetchProvinces(selectedOption.value);
    } else {
      setTableData5([]);
    }
  };

  const handleProvinceChange = (e, province) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectedProvinces((prev) => {
        if (!prev.some((p) => p.value === province.value)) {
          return [...prev, { value: province.value, label: province.label }];
        }
        return prev;
      });
    } else {
      setSelectedProvinces((prev) => prev.filter((p) => p.value !== province.value));
    }
  };

  const handleSelectedUserProvinceChange = (e, province) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setUserProvinces((prev) => {
        if (!prev.some((p) => p.value === province.value)) {
          return [...prev, { value: province.value, label: province.label }];
        }
        return prev;
      });
    } else {
      setUserProvinces((prev) => prev.filter((p) => p.value !== province.value));
    }
  };

  // API calls
  const createUser = async () => {
    setLoading(true);
    const mergedProvinces = [
      ...selectedProvinces.map((province) => province.value),
    ];

    try {
      const response = await axios.post(
        `${BASE_URL}/assign-compliance-to-province`,
        {
          user_id: selectedUser?.user_id,
          province_id: mergedProvinces
        },
        { headers }
      );
      console.log(response);
      fetchData();
      setSelectedProvinces([]);
      handleClose();

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      console.log(response.data);
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const createUser1 = async () => {
    setLoading(true);
    const mergedProvinces = [
      ...userProvinces.map((province) => province.value),
    ];

    try {
      const response = await axios.post(
        `${BASE_URL}/deassign-compliance-from-province`,
        {
          user_id: selectedUser?.user_id,
          province_id: mergedProvinces
        },
        { headers }
      );
      console.log(response);
      fetchData();
      handleClose2();

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      console.log(response.data);
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  };

  // Filter users based on search term
  const filteredUsers = users.filter(user =>
    user?.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user?.user_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user?.user_phone_number?.includes(searchTerm)
  );

  return (
    <div>
      <HeaderNav />

      {/* Assign Province Modal */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Assign Provinces to {selectedUser?.user_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <Form style={{ marginBottom: 20 }}>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
                  <Form.Label>Continent</Form.Label>
                  <Select
                    onChange={(selectedOption) => handleContinentChange(selectedOption)}
                    options={selectOptions}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "300px",
                        maxWidth: "450px",
                        overflowY: "auto",
                      }),
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-1">
                  <Form.Label>Region</Form.Label>
                  <Select
                    onChange={(selectedOption) => handleRegionChange(selectedOption)}
                    options={tableData4}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "300px",
                        maxWidth: "450px",
                        overflowY: "auto",
                      }),
                    }}
                  />
                </Form.Group>
              </div>
            </div>

            <div style={{ marginTop: 10 }} />

            <Accordion>
              <Accordion.Item>
                <Accordion.Header>Assigned Provinces</Accordion.Header>
                <Accordion.Body style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  <div className="row">
                    {selectedUser && getAssignedProvinces(selectedUser).length > 0 ? (
                      getAssignedProvinces(selectedUser).map((province) => (
                        <div key={province.value} className="col-md-4 mb-3">
                          <label className="d-flex align-items-center">
                            <span>{province.label}</span>
                          </label>
                        </div>
                      ))
                    ) : (
                      <p>No provinces have been assigned to this user. Please select a continent and region to start with.</p>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item>
                <Accordion.Header>Assign User to Province</Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    {selectedProvinces && selectedProvinces.length > 0 && (
                      <>
                        <h6 style={{ fontWeight: 700 }}>Selected Provinces</h6>
                        {selectedProvinces.map((province) => (
                          <div key={province.value} className="col-md-4 mb-3">
                            <label className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                value={province.value}
                                className="me-2"
                                checked={true}
                                onChange={(e) => handleProvinceChange(e, province)}
                              />
                              <span>{province.label}</span>
                            </label>
                          </div>
                        ))}
                        <hr />
                      </>
                    )}
                    <div style={{ marginTop: 10 }} />
                    <h6 style={{ fontWeight: 700 }}>Provinces</h6>
                    {tableData5 && tableData5.length > 0 ? (
                      tableData5.map((province) => {
                        const isSelected = selectedProvinces.some((p) => p.value === province.value);
                        return (
                          <div key={province.value} className="col-md-4 mb-3">
                            <label className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                value={province.value}
                                className="me-2"
                                checked={isSelected}
                                onChange={(e) => handleProvinceChange(e, province)}
                              />
                              <span>{province.label}</span>
                            </label>
                          </div>
                        );
                      })
                    ) : (
                      <p>No provinces to display. Please select a continent and region to start with.</p>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button variant="success" onClick={createUser} style={{ backgroundColor: '#174384', borderColor: '#174384' }}>
            {loading ? (
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>
                  Saving Changes, Please wait...
                </span>
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Unassign Province Modal */}
      <Modal show={show2} onHide={handleClose2} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Unassign Provinces </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ marginBottom: 20 }}>
            <div style={{ marginTop: 10 }} />
            <Accordion>
              <Accordion.Item>
                <Accordion.Header>Assigned Provinces</Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    {selectedUser && getAssignedProvinces(selectedUser).length > 0 ? (
                      getAssignedProvinces(selectedUser).map((province) => {
                        const isChecked = userProvinces.some((p) => p.value === province.value);
                        return (
                          <div key={province.value} className="col-md-4 mb-3">
                            <label className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                value={province.value}
                                className="me-2"
                                checked={isChecked}
                                onChange={(e) => handleSelectedUserProvinceChange(e, province)}
                              />
                              <span>{province.label}</span>
                            </label>
                          </div>
                        );
                      })
                    ) : (
                      <p>No provinces have been assigned to this user.</p>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Form>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose2}>
              Go back
            </Button>
            <Button variant="success" onClick={createUser1} style={{ backgroundColor: '#174384', borderColor: '#174384' }}>
              {loading ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Saving Changes, Please wait...
                  </span>
                </>
              ) : (
                "Save Changes"
              )}
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>

      {/* Main Table */}
      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Compliance-Province Assignment</h3>
        <p className={classes.prgText}>View and Assign Compliance Province.</p>

        <div className={classes.subContainer}>
          <div className={classes.searchInputWrapper}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={classes.searchInput}
              placeholder="Search users..."
            />
            <Search className={classes.searchIcon} size={16} />
          </div>
          <div className={classes.statCount}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Users</p>
              {loading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px' }}></div>
              ) : (
                <p className={classes.txtHds}>{users.length}</p>
              )}
            </div>
          </div>
        </div>

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Assigned Provinces</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 7 }).map((_, index) => (
                  <tr key={`skeleton-${index}`}>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '200px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div>
                    </td>
                    <td className={classes.btnAction}>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                        <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : filteredUsers.length > 0 ? (
                filteredUsers.map((user, index) => (
                  <tr key={user.user_id || index}>
                    <td className={classes.textby}>{index + 1}</td>
                    <td className={classes.textby}>
                      <span className={classes.statucColor}>
                        {user.user_name || 'N/A'}
                      </span>
                    </td>
                    <td className={classes.textby}>
                      {user.user_email || 'N/A'}
                    </td>
                    <td className={classes.textby}>
                      {user.user_phone_number || 'N/A'}
                    </td>
                    <td className={classes.textby}>
                      {user.assigned_provinces?.length || 0} provinces
                    </td>
                    <td className={classes.btnAction}>
                      {/* Green for Assign */}
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: 0,
                          cursor: "pointer",
                          marginRight: '10px',
                          color: '#28a745'
                        }}
                        onClick={() => handleShow(user)}
                        title="Assign User to Province"
                      >
                        <BiSolidEdit size={20} />
                      </button>

                      {/* Red for Unassign */}
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: 0,
                          cursor: "pointer",
                          color: '#dc3545'
                        }}
                        onClick={() => handleShow1(user)}
                        title="Unassign User from Province"
                      >
                        <BiSolidEdit size={20} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center p-4">
                    {searchTerm ? "No users found matching your search" : "No users available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className={classes.paginationStyle}>
            <div className={classes.footerSubOne}>
              <button className={classes.btnFirst}>First</button>
              <span className={classes.ftOne}>
                <button className={`${classes.pageNumber} ${classes.active}`}>1</button>
                <button className={classes.pageNumber}>2</button>
              </span>
              <button className={classes.btnSec}>Last</button>
            </div>
            <p className={classes.displayPag}>
              Displaying 1-{filteredUsers.length} of {filteredUsers.length}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignUser